import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

type FeeDescriptionProps = {
  defaultFeesDescription: null | string | undefined;
};

export const FeeDescription = ({ defaultFeesDescription }: FeeDescriptionProps) => {
  const id = useId();
  const { t } = useTranslation();

  return (
    <FormControl fullWidth margin="dense">
      <FormLabel htmlFor={id}>{t('Additional description')}</FormLabel>
      <TextField disabled id={id} multiline placeholder={t('N / A')} rows={4} value={defaultFeesDescription ?? ''} />
    </FormControl>
  );
};
